import React from 'react';
import { useAuth } from '../contexts/AuthContext';

interface AuthLoadingWrapperProps {
  children: React.ReactNode;
}

const AuthLoadingWrapper: React.FC<AuthLoadingWrapperProps> = ({ children }) => {
  const { isAuthenticated, isSessionReady, loading } = useAuth();

  // Show loading while session is being initialized
  if (loading || !isSessionReady) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Verificando autenticación...
      </div>
    );
  }

  // If not authenticated, let ProtectedRoute handle the redirect
  if (!isAuthenticated) {
    return <>{children}</>;
  }

  // If authenticated and session is ready, show the content
  return <>{children}</>;
};

export default AuthLoadingWrapper;
